import styled, { css } from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'
import { ICONS } from '../../themes'

// Modifier (props)
// ============================================================

// Core
// ============================================================
export const ModalStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  position: fixed;
  opacity: 0;
  display: block;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${VARIABLES.Z_INDEXS.NEGATIVE_3};
  justify-content: center;
  transition: all ${VARIABLES.TRANSITIONS.FAST} ease-in;
  overflow-y: auto;

  /* Child element styles
  ------------------------------- */
  /* .form-group {
    .form-group-control {
      max-width: 100%;
    }
  } */

  .form-actions-center {
    width: 160px;
    margin: 0 auto;
  }

  .modal-custom-content {
    ${props => {
      return css`
        max-width: ${props.setWidth ? props.setWidth : '100%'};
      `
    }}
  }

  /* States
  ------------------------------- */
  &.is-open {
    opacity: 1;
    z-index: ${VARIABLES.Z_INDEXS.LV_10};
    width: 100%;
    height: 100%;
    transition: all ${VARIABLES.TRANSITIONS.FAST} ease-out;

    /* .modal-custom-content {
      top: 0;
    } */
  }

  /* Modifiers
  ------------------------------- */
  &.modals-time-out div.modal-custom-content {
    max-width: 700px;
  }

  &.modal-auction-event-close-log div.modal-custom-content {
    max-width: 980px;
  }

  &.modals-submit-award div.modal-custom-content {
    max-width: 980px;
  }
  &.modals-history-of-supplier div.modal-custom-content {
    max-width: 75vw;
    .table-header-freeze-wrapper {
      max-height: 500px;
      overflow-y: auto;
      overflow-x: auto;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }
    .modal-history-of-supplier {
      .no {
        flex: 0 0 5%;
      }
      .item-name {
        flex: 0 0 15%;
      }
      .description {
        white-space: normal;
      }
      .quantity {
        flex: 0 0 10%;
        justify-content: end;
        text-align: right;
      }
      .uom {
        flex: 0 0 10%;
        justify-content: center;
        text-align: center;
      }
      .unit-price {
        flex: 0 0 15%;
        justify-content: end;
        text-align: right;
      }
      .total-price {
        flex: 0 0 15%;
        justify-content: end;
        text-align: right;
      }
    }
  }
  &#allowselection div.modal-custom-dialog div.modal-custom-content {
    max-width: 58vw;
  }
  &.theme-blue {
    .modal-custom-header {
      background-color: ${VARIABLES.COLORS.BLUE_1};
      color: white;
    }
  }
  &.theme-red {
    .modal-custom-header {
      background-color: ${VARIABLES.COLORS.RED_1};
      color: white;
    }
  }

  &.theme-yellow {
    .modal-custom-header {
      background-color: ${VARIABLES.COLORS.YELLOW_1};
      color: white;
    }
  }

  &.forgot-password {
    .modal-custom-content {
      max-width: 935px;
    }

    .modal-custom-body {
      padding: 58px 127px;

      .caption {
        margin-bottom: 30px;
        color: ${VARIABLES.COLORS.GRAY_3};
      }

      .section {
        &.forgot-password-form {
          flex-wrap: wrap;
          max-width: 320px;

          .input-control {
            max-width: 100%;
          }

          .invalid-message {
            color: ${VARIABLES.COLORS.RED_1};
            font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
          }

          .button {
            margin-left: 0;
          }
        }
      }
      .loader {
        border: 4px solid #4b4acb;
        border-radius: 50%;
        border-top: 4px solid #f3f3f3;
        width: 20px;
        height: 20px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
      }

      @-webkit-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
        }
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  &.history {
    .modal-custom-content {
      max-width: 768px;
    }

    .modal-custom-body {
      padding: 23px 20px 30px;

      .caption {
        margin-bottom: 30px;
        color: ${VARIABLES.COLORS.GRAY_3};
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
    }
  }

  &.reschedule {
    .modal-custom-content {
      max-width: 768px;
    }

    .date-picker-wrapper {
      width: calc(100% - 120px);
    }

    .form-group {
      .select-control {
        max-width: 120px;
        min-width: 60px;
        margin-left: 10px;
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
    }
  }

  &.history-user-management {
    .modal-custom-content {
      max-width: 1400px;
    }

    .modal-custom-body {
      padding: 23px 20px 30px;

      .caption {
        margin-bottom: 30px;
        color: ${VARIABLES.COLORS.GRAY_3};
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
    }

    .table {
      &.history {
        .table-row {
          .action {
            flex: 0 0 25%;
            white-space: break-spaces;
            text-overflow: inherit;
          }

          .detail {
            flex: 0 0 37%;
          }

          .action-by {
            flex: 0 0 19%;
          }

          .create-date {
            flex: 0 0 19%;
          }
        }
      }
    }

    .table-column {
      height: auto;
      max-height: none;
    }

    .detail-groups {
      flex-wrap: wrap;

      label {
        position: relative;
        padding-left: 20px;
        margin-top: 5px;
        width: 100%;

        &:before {
          content: '•';
          color: ${VARIABLES.COLORS.BLUE_1};
          position: absolute;
          transform: translate(-50%, -51%);
          top: 50%;
          left: 5px;
          font-size: 60px;
        }
      }
    }
  }

  &.history-log {
    .modal-custom-content {
      max-width: 850px;
    }

    .history-log-data {
      .create-date,
      .action {
        flex: 0 0 30%;
      }

      .action {
        justify-content: center;
        text-align: center;
        white-space: normal;

        .section {
          justify-content: center;
        }
      }

      .detail {
        flex: 0 0 40.1%;
        white-space: normal;
      }
    }

    .table-header-freeze-wrapper {
      max-height: 500px;
      overflow-y: auto;
      overflow-x: hidden;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }
  }

  &.template-manager {
    .modal-custom-content {
      max-width: 529px;
    }

    .modal-custom-body {
      padding: 20px 29px 20px;
      min-height: 40vh;

      .form-wrapper {
        padding: 0;

        .form-group {
          .input-control {
            flex: 1 1 auto;
          }

          .button {
            &.add-topic {
              flex: 0 0 137px;
              margin-left: 15px;
              margin-top: 0;
            }
          }
        }

        &.add-topic {
          margin-top: 30px;
        }
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
    }
  }

  &.edit-site {
    .modal-custom-content {
      max-width: 1024px;

      .company-name .table-row {
        .code {
          flex: 0 0 25%;
        }

        .company {
          flex: 0 0 37%;
        }

        .address {
          flex: 0 0 39%;
        }
      }
    }
  }

  &.add-new {
    .modal-custom-content {
      /* max-width: 1024px; */
      max-width: 900px;

      .data-table {
        margin-bottom: 30px;
      }
      .company-name .table-row,
      .table-column {
        .code {
          flex: 0 0 20%;
        }

        .company {
          flex: 0 0 35%;
        }

        .address {
          flex: 0 0 35%;
        }
        .actions {
          flex: 0 0 10%;
        }
      }
      .form-actions-add-more {
        display: inline-block;
        margin: 0 auto;
        .theme-blue {
          width: 9.375em;
          margin: 0 auto;
        }
      }
    }

    .actions {
      .link {
        margin: 10px auto 0;
      }
    }
  }

  &.supplier-registration {
    .modal-custom-content {
      max-width: 768px;
    }

    .modal-custom-body {
      padding: 20px 29px;

      .form-wrapper {
        padding: 0;

        .form-group {
          padding-top: 10px;

          .input-control {
            max-width: 400px;
            flex: 0 0 400px;
          }
          .label {
            flex: 0 0 155px;
            justify-content: start;
          }

          .checkbox-list {
            margin-top: 10px;
          }

          .checkbox {
            margin-bottom: 8px;
          }
        }
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
    }
  }

  &.supplier-contact {
    .modal-custom-content {
      max-width: 783px;
    }

    .modal-custom-body {
      padding: 20px 29px 20px;
      min-height: 495px;

      .section {
        flex-wrap: wrap;
        margin-bottom: 40px;

        .title {
          font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.LG};
          font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
          color: ${VARIABLES.COLORS.GRAY_3};
          margin-bottom: 23px;
          width: 100%;
        }

        .data {
          color: ${VARIABLES.COLORS.GRAY_3};
        }

        &:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
    }
  }

  &.sourcing {
    .modal-custom-content {
      max-width: 92%;
      max-width: 92vw;
    }

    .tax-id {
      flex: 0 0 18%;
    }

    .company-name {
      flex: 0 0 30%;
      min-width: 0;
      text-overflow: inherit;
      white-space: break-spaces;
    }

    .branch-number {
      flex: 0 0 12%;
    }

    .vendor-code {
      flex: 0 0 12%;
    }

    .contact-name {
      flex: 0 0 23%;
    }

    .email {
      flex: 0 0 28%;
    }

    // .table-column {
    //   &.email {
    //     flex: 0 0 28%;
    //   }
    // }

    .form-group-inner-wrapper {
      justify-content: center;
    }

    .fake-label {
      color: ${VARIABLES.COLORS.BLUE_1};
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
      align-items: center;
      padding: 15px 29px;
    }

    .popup-sourcing {
      overflow: auto;
      /* max-height: 600px;
      max-height: 60vh; */
      max-height: calc(
        100vh - 340px
      ); /* Fixed style for test responsive 1263x948px */
      display: flex;

      /* width */
      ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
        border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }

      .tbody {
        width: 100%;
      }

      .header-freeze ~ .table {
        max-height: 550px;
        max-height: 60vh;
        display: flex;

        /* width */
        ::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
          background: ${VARIABLES.COLORS.GRAY_2};
          border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: ${VARIABLES.COLORS.BLUE_4};
          border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: ${VARIABLES.COLORS.BLUE_1};
        }
      }
    }
  }

  &.buyer-info {
    .modal-custom-content {
      max-width: 1391px;
    }
    .style-table {
      max-height: 80vh;
    }
  }

  &.edit-score {
    .modal-custom-content {
      max-width: 632px;
    }

    .modal-custom-body {
      padding: 20px 29px;

      .category-score {
        color: ${VARIABLES.COLORS.BLUE_1};
        margin-bottom: 15px;

        .header {
          font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
          margin-right: 15px;
        }
      }

      .form-wrapper {
        padding: 0;

        /* .form-group-header {
          margin-bottom: 0;
          color: ${VARIABLES.COLORS.GRAY_3};
        } */

        .form-group {
          label {
            /* color: ${VARIABLES.COLORS.GRAY_3};
            text-align: left; */
            justify-content: flex-start;
          }

          .input-control {
            flex: 1 1 auto;
            min-width: 100px;
            max-width: 160px;
            margin-right: 15px;
          }

          .unit {
            color: ${VARIABLES.COLORS.BLUE_1};
          }

          .message {
            height: 16px;
            margin-bottom: 2px;
          }
        }
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
    }
  }

  &.popup {
    .modal-custom-content {
      max-width: 575px;
    }

    .modal-custom-body {
      padding: 33px 20px;
      min-height: 150px;
      align-items: center;
      display: flex;
      justify-content: center;
      text-align: center;
      word-wrap: break-word;
      white-space: normal;

      .image-control {
        &.warning {
          margin-right: 16px;
          width: 37px;
          flex: 0 0 37px;
        }
      }

      p {
        margin-top: 15px;
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
      padding: 15px 29px;

      .button {
        width: 150px;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &.warning {
      .modal-custom-body {
        justify-content: flex-start;
        padding-left: 98px;
        padding-right: 80px;
        text-align: left;
        font-weight: 300;
        word-break: break-word;
      }
    }
  }

  &.cropper {
    .modal-custom-content {
      max-width: 820px;
    }

    .modal-custom-body {
      padding: 0;
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: space-between;
      align-items: center;
      padding: 15px 29px;

      .zoom-controls-wrapper {
        .slider {
          ${props => {
            return css`
              zoom: ${props.demoZoomReverse};
            `
          }}
        }

        .MuiSlider-thumb {
          ${props => {
            return css`
              zoom: ${props.demoZoom};
            `
          }}
        }
      }

      .actions {
        width: auto;

        .button {
          width: 150px;
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  &.invite-supplier {
    .modal-custom-content {
      max-width: 785px;
    }

    .modal-custom-body {
      padding: 20px 29px 70px;
      min-height: 150px;

      .form-wrapper {
        /* max-width: 470px; */
        padding: 0;

        .form-group {
          label {
            flex: 0 0 150px;
            justify-content: flex-start;
            text-align: left;
            /* color: ${VARIABLES.COLORS.GRAY_3}; */
          }

          .input-control {
            flex: 1 1 auto;
            width: 100%;

            .input {
              color: ${VARIABLES.COLORS.BLUE_1};
            }
          }

          .message {
            height: 17px;
            margin-bottom: 3px;
          }
        }
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: space-between;
      padding: 15px 29px;

      .button {
        width: 150px;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  &.update-offline-comprehensive-assessment {
    .modal-custom-dialog {
      height: 100%;
    }

    .modal-custom-content {
      max-width: 840px;
      //height: 100%;
      max-height: calc(100% - 60px);
      background-color: white;
      border-radius: ${VARIABLES.BORDER_RADIUSES.SM};
      //overflow: hidden;
      height: auto;
      display: flex;

      .form-wrapper {
        max-height: 100%;
        display: flex;
        flex-wrap: wrap;
      }
    }

    .modal-custom-header {
      width: 100%;
    }

    .modal-custom-body {
      padding: 5px 29px 55px;
      min-height: 300px;
      /* max-height: calc(100% - 177px); */
      max-height: calc(100% - 118px);
      height: auto;
      overflow-y: auto;
      /* margin: 15px 0; */
      width: 100%;

      .form-wrapper {
        padding: 0;

        .form-group {
          label {
            flex: 0 0 150px;
          }

          .input-control {
            flex: 1 1 auto;
            &.is-disabled {
              .input {
                border: 1px solid ${VARIABLES.COLORS.GRAY_2} !important;
                background-color: white !important;
              }
            }
          }

          .message {
            height: 17px;
            opacity: inherit;
          }

          &.select-template {
            margin-top: 20px;

            label {
              flex: 0 0 210px;
            }

            .select-template {
              max-width: 320px;
            }

            .button {
              width: 125px;
              margin-left: 14px;
            }
          }
        }

        .template-form-group {
          display: flex;
          flex-wrap: nowrap;
          margin-top: 30px;
          align-items: start;

          .input-content {
            flex: 0 0 560px;
            flex-wrap: wrap;
            max-width: 560px;

            .template-form-group {
              flex-wrap: wrap;
            }

            .form-group {
              &.template-name {
                position: relative;

                .input-control {
                  max-width: none;

                  .input {
                    padding-right: 100px;
                  }
                }

                .button {
                  &.link {
                    position: absolute;
                    // z-index: 2;
                    color: ${VARIABLES.COLORS.RED_1};
                    right: 15px;
                    width: auto;
                  }
                }
              }
            }

            .add-date {
              margin-top: 16px;
              margin-bottom: 11px;
              color: ${VARIABLES.COLORS.GRAY_3};
            }

            .offline-comprehensive-assessment-block {
              margin: 15px 0 5px;

              .block-order {
                flex: 0 0 40px;
                color: ${VARIABLES.COLORS.GRAY_3};
              }

              .block-detail {
                flex: 1 1 auto;
                flex-wrap: wrap;
                max-width: calc(100% - 40px);

                .title {
                  width: 100%;
                  color: ${VARIABLES.COLORS.GRAY_3};
                }

                .form-group {
                  width: 100%;
                  margin-top: 10px;

                  label {
                    flex: 0 0 82px;
                    max-width: 82px;
                    margin-right: 10px;
                    justify-content: flex-start;
                    text-align: left;
                    color: ${VARIABLES.COLORS.GRAY_3};
                  }

                  .form-group-control {
                    max-width: 320px;
                    width: 100%;
                  }

                  .input-control {
                    max-width: 100%;
                  }

                  .input-textarea-control {
                    max-width: 100%;
                    min-width: 100%;

                    .textarea {
                      max-width: 100%;
                      min-width: 100%;
                      max-height: 125px;
                      min-height: 125px;
                    }
                  }
                }
              }
            }

            .total-score-block {
              .form-group {
                width: 100%;
                margin-top: 10px;

                label {
                  flex: 0 0 122px;
                  max-width: 122px;
                  margin-right: 10px;
                  justify-content: flex-start;
                  text-align: left;
                  color: ${VARIABLES.COLORS.GRAY_3};
                  font-weight: ${VARIABLES.TYPOGRAPHYS.FIRST_SEMI_BOLD};

                  &.required {
                    position: relative;

                    &:before {
                      content: '*';
                      margin-right: 5px;
                      display: inline;
                      position: relative;
                      color: ${VARIABLES.COLORS.RED_1};
                    }
                  }
                }

                .form-group-control {
                  max-width: 320px;
                  width: 100%;
                }

                .input-control {
                  max-width: 100%;
                }
              }
            }
          }

          .input-attach {
            margin-left: 14px;
            flex: 1 1 auto;
            flex-direction: column;
            max-width: calc(100% - 574px);
            position: relative;

            .button {
              &.attach {
                margin-bottom: 16px;
                width: 125px;
              }
            }

            .btn-array-upload {
              width: 125px;
              height: 42px;
              overflow: hidden;
              position: absolute;
              z-index: 1;
              cursor: pointer;
              text-indent: -9999px;
            }

            .button-upload-files {
              width: 125px;
              height: 42px;
              border-radius: 6px;
              cursor: pointer;
              color: white;
              background-color: ${VARIABLES.COLORS.BLUE_1};
              font-weight: 600;
              font-size: 17px;
              white-space: nowrap;
              display: flex;
              align-items: center;
              justify-content: center;
              &:hover {
                background-color: ${VARIABLES.COLORS.BLUE_3};
                cursor: pointer;
              }
            }

            .files-wrapper {
              flex-direction: column;
              align-items: flex-start;
              margin-top: 15px;

              .button {
                text-decoration: underline;
                font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
                color: ${VARIABLES.COLORS.BLUE_2};

                &.file-link {
                  background-color: ${VARIABLES.COLORS.GRAY_7};
                  border: 1px solid ${VARIABLES.COLORS.GRAY_2};
                  display: inline-flex;
                  align-items: center;
                  padding: 7px 17px 7px 42px;
                  width: auto;
                  max-width: 500px;
                  border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
                  text-decoration: none;
                  margin-bottom: 10px;
                  position: relative;
                  max-width: 100%;
                  cursor: pointer;

                  .file-name {
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }

                  &:before {
                    content: '';
                    display: inline-block;
                    background-image: url(${ICONS['icon-download-file.png']});
                    width: 13px;
                    height: 16px;
                    margin-right: 15px;
                    position: absolute;
                    top: 50%;
                    left: 19px;
                    transform: translateY(-50%);
                  }

                  .button {
                    flex: 0 0 16px;
                    margin-left: 25px;

                    .delete-circle-icon {
                      flex: 0 0 16px;
                    }

                    &:hover {
                      filter: brightness(0.8);
                    }
                  }
                }

                &:hover {
                  color: ${VARIABLES.COLORS.BLUE_5};
                }
              }
            }
          }
        }
      }

      /* width */
      ::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: ${VARIABLES.COLORS.GRAY_2};
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: ${VARIABLES.COLORS.BLUE_4};
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
        background: ${VARIABLES.COLORS.BLUE_1};
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
      padding: 15px 29px;
      width: 100%;

      .button {
        width: 150px;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  &.terms-conditions {
    p,
    ol,
    ul,
    li,
    dl,
    dt,
    dd,
    pre,
    iframe,
    hr,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: revert;
      padding: revert;
    }
    ul {
      list-style: inherit;
    }

    .form-group .form-group-control {
      max-width: inherit;
    }
    .modal-custom-content {
      max-width: 800px;
    }

    /* .modal-custom-background {
      background: ${VARIABLES.COLORS.GRAY_9};
    } */

    .modal-custom-body {
      padding-right: 15px;
      .terms-conditions-body {
        min-height: 300px;
        max-height: 400px;
        height: auto;
        overflow-y: auto;
        width: 100%;
        padding-right: 15px;
        flex-wrap: wrap;
        text-align: left;

        ::-webkit-scrollbar {
          width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
          background: ${VARIABLES.COLORS.GRAY_2};
          border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: ${VARIABLES.COLORS.BLUE_1};
          border-radius: ${VARIABLES.BORDER_RADIUSES.XXS};
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: ${VARIABLES.COLORS.BLUE_4};
        }
      }
    }
  }

  &.purchasing-site {
    .modal-custom-content {
      max-width: 785px;
    }
    /* &.modals-re-submit-award {
      .modal-custom-body {
        min-height: 0px !important;
      }
    } */
    .modal-custom-body {
      padding: 20px 29px 70px;
      min-height: 350px;

      .company-name .table-row {
        .code {
          flex: 0 0 35%;
        }

        .company {
          flex: 0 0 65%;
          text-align: center;
          justify-content: center;
        }
      }
    }

    .modal-custom-footer {
      background-color: ${VARIABLES.COLORS.GRAY_8};
      justify-content: flex-end;
      padding: 15px 29px;

      .button {
        width: 150px;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  &.add-supplier {
    .modal-custom-body {
      .form-group {
        max-width: none;

        .form-group-control {
          max-width: none;
        }

        .form-group-inner-wrapper {
          justify-content: center;
        }

        .input-control {
          flex: 1 1 auto;
          max-width: 390px;
        }
      }
    }
  }

  &.request-unseal {
    .modal-custom-body {
      .form-group {
        max-width: none;

        .form-group-control {
          max-width: none;
        }

        .form-group-inner-wrapper {
          justify-content: center;
        }

        .input-control {
          flex: 1 1 auto;
          max-width: 390px;
        }
      }
    }
  }

  &.modal-warning {
    /* font-size: 20px; */

    p {
      margin-bottom: 1rem;
    }
  }

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1367.98px) {
    &.modal-reject-supplier {
      .form-group > label {
        min-width: 150px;
      }
    }
  }

  @media all and (max-width: 1600.98px) {
    /* &.add-new {
      .modal-custom-content {
        .form-actions-add-more {
          .theme-blue {
            padding-left: 100px;
            padding-right: 100px;
          }
        }
      }
    } */

    &.template-manager {
      .modal-custom-body {
        .form-wrapper {
          .form-group-control {
            max-width: 100%;
          }

          .form-group {
            .input-control {
              flex: 1 1 auto;
            }

            .button {
              &.add-topic {
                flex: 0 0 130px;
              }
            }
          }
        }
      }

      .modal-custom-footer {
        background-color: ${VARIABLES.COLORS.GRAY_8};
        justify-content: flex-end;
      }
    }

    .section {
      &.form-group {
        .input-textarea-control {
          max-width: 100%;
        }
      }
    }
  }

  @media all and (max-width: 1440.98px) {
    &.forgot-password {
      .modal-custom-content {
        max-width: 720px;
      }

      .modal-custom-body {
        .caption {
          margin-bottom: 25px;
        }

        .section {
          &.forgot-password-form {
            max-width: 300px;
          }
        }
      }
    }

    /* &.add-new {
      .modal-custom-content {
        .form-actions-add-more {
          .theme-blue {
            padding-left: 90px;
            padding-right: 90px;
          }
        }
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    &.forgot-password {
      .modal-custom-content {
        max-width: 640px;
      }

      .modal-custom-body {
        .section {
          &.forgot-password-form {
            max-width: 280px;
          }
        }
      }
    }

    /* &.add-new {
      .modal-custom-content {
        .form-actions-add-more {
          .theme-blue {
            padding-left: 80px;
            padding-right: 80px;
          }
        }
      }

      .actions {
        .link {
          margin: 8px auto 0;
        }
      }
    } */

    /* width */
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
  }

  @media all and (max-width: 1280.98px) {
    &.forgot-password {
      .modal-custom-content {
        max-width: 520px;
      }

      .modal-custom-body {
        .caption {
          margin-bottom: 20px;
        }

        .section {
          &.forgot-password-form {
            max-width: 260px;
          }
        }
      }
    }

    &.edit-score {
      /* .modal-custom-content {
        max-width: 500px;
      } */

      .modal-custom-body {
        .category-score {
          margin-bottom: 10px;
        }

        .form-wrapper {
          .form-group {
            label {
              flex: 0 0 95px;
            }

            .input-control {
              min-width: 130px;
              max-width: 130px;
            }
          }
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    &.edit-score {
      /* .modal-custom-content {
        max-width: 400px;
      } */

      .modal-custom-body {
        .form-wrapper {
          .form-group {
            label {
              flex: 0 0 80px;
            }

            .input-control {
              min-width: 100px;
              max-width: 100px;
            }
          }
        }
      }
    }
  }
`

export const ModalDialogStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  position: relative;
  min-height: 100%;
  max-width: none;
  margin: 0;
  align-items: center;
  justify-content: center;
  padding: 4rem;

  /* Child element styles
  ------------------------------- */

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
  }

  @media all and (max-width: 1280.98px) {
  }

  @media all and (max-width: 1024.98px) {
  }
`

export const ModalContentStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  position: relative;
  display: block;
  width: 100%;
  /* max-width: 1045px; */
  transition: all ${VARIABLES.TRANSITIONS.FAST} ease-out;
  /* margin: 0 auto; */
  /* margin: 4rem; */
  /* padding: 4rem; */

  /* Child element styles
  ------------------------------- */
  .default {
    align-items: center;
    justify-content: center;
    color: ${VARIABLES.COLORS.BLUE_1};
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .text-center {
    text-align: center;
    &.text-blue {
      color: ${VARIABLES.COLORS.BLUE_1};
      font-size: 1.25em;
      font-weight: 500;
    }
  }

  .blink {
    animation: change-color 1s linear infinite;
  }

  @keyframes change-color {
    0% {
      color: black;
    }
    50% {
      color: red;
    }
    100% {
      color: black;
    }
  }

  .form-group {
    margin-bottom: 0.625em;
  }

  .modal-custom-body {
    .form-group {
      .input-textarea-control {
        max-width: 100%;
      }

      .select-control {
        max-width: 100%;
      }

      .message {
        color: ${VARIABLES.COLORS.RED_1};
        opacity: 1;
        height: auto;
        padding-left: 10px;
        font-size: 10px;
        height: 16px;
        margin-bottom: 7px;
      }
    }
  }

  .auction-event-log {
    max-height: 400px;
    overflow-y: auto;
    white-space: pre-wrap;
  }

  .body-content-warning {
    margin: 20px 0 20px 0;
    justify-content: center;
    .image-warning-wrapper {
      width: fit-content;
      justify-content: end;
      .icon-warning {
        width: 50px;
        filter: grayscale(100%) brightness(40%) sepia(100%) hue-rotate(-50deg)
          saturate(600%) contrast(0.8);
        margin-right: 10px;
      }
    }
    .text-detail-wrapper {
      display: block;
      width: fit-content;
      text-align: center;
      color: ${VARIABLES.COLORS.BLUE_1};
      label {
        font-size: 1.25em;
        font-weight: 500;
        line-height: 2.5;
      }
    }
  }

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */
  /* &.widthModal {
    max-width: 30%;
  } */

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1367.98px) {
  }

  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
    /* width: 90%;
    max-width: 90%; */
    /* padding: 6rem; */

    .modal-custom-body {
      .form-group > label {
        max-width: 120px;
      }
    }
  }

  @media all and (max-width: 1280.98px) {
  }

  @media all and (max-width: 1024.98px) {
  }
`

export const ModalBackgroundStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background-color: ${VARIABLES.COLORS.OVERLAY_2};

  /* Child element styles
  ------------------------------- */

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
  }

  @media all and (max-width: 1280.98px) {
  }

  @media all and (max-width: 1024.98px) {
  }
`

export const ModalHeaderStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 75px;
  border-top-left-radius: ${VARIABLES.BORDER_RADIUSES.SM};
  border-top-right-radius: ${VARIABLES.BORDER_RADIUSES.SM};
  padding: 23px 29px;
  font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
  font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.LG};

  /* Child element styles
  ------------------------------- */

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
    min-height: 70px;
    font-size: 18px;
    padding: 20px 25px;
  }

  @media all and (max-width: 1366.98px) {
    min-height: 65px;
    font-size: 17px;
    padding: 17px 22px;
  }

  @media all and (max-width: 1280.98px) {
    min-height: 60px;
    font-size: 16px;
    padding: 15px 20px;
  }

  @media all and (max-width: 1024.98px) {
    min-height: 55px;
    font-size: 15px;
    padding: 12px 15px;
  }
`

export const ModalBodyStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  background-color: ${VARIABLES.COLORS.WHITE};
  padding: 25px 25px 35px;
  /* max-height: calc(100vh - 300px);
  overflow-y: scroll; */

  /* Child element styles
  ------------------------------- */
  .cropper-control {
    position: relative;
    width: 100%;
    height: 360px;

    .reactEasyCrop_Container {
      .reactEasyCrop_CropArea {
        border: 0;
      }
    }
  }

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
    /* padding: 20px 25px !important; */
  }

  @media all and (max-width: 1366.98px) {
    /* padding: 17px 22px !important; */
  }

  @media all and (max-width: 1280.98px) {
    /* padding: 15px 20px !important; */
  }

  @media all and (max-width: 1024.98px) {
    /* padding: 12px 15px !important; */
  }
`

export const ModalFooterStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  justify-content: flex-end;
  border-bottom-left-radius: ${VARIABLES.BORDER_RADIUSES.SM};
  border-bottom-right-radius: ${VARIABLES.BORDER_RADIUSES.SM};
  padding: 15px;
  background-color: ${VARIABLES.COLORS.GRAY_8};
  border-top: 1px solid ${VARIABLES.COLORS.GRAY_2};

  /* Child element styles
  ------------------------------- */
  .footer-validation-select {
    width: 100%;
    display: flex;
    align-items: center;
    p {
      color: red;
    }
  }
  /* & > * {
    margin: 0;
  } */

  .button {
    margin-left: 15px;
    padding-left: 15px;
    padding-right: 15px;
    flex-basis: content;
    min-width: 150px;

    /* &.close {
      flex: 0 0 150px;
    }

    &.cancel {
      flex: 0 0 150px;
    }

    &.save {
      flex: 0 0 150px;
    } */

    /* &:last-child {
      margin-right: 0;
    } */
  }

  .zoom-controls-wrapper {
    width: 190px;
    height: 26px;
    display: flex;
    align-items: center;

    .slider {
      margin: 0 20px;

      .MuiSlider-track {
        background-color: ${VARIABLES.COLORS.BLUE_1};
        height: 3px;
      }

      .MuiSlider-thumb {
        width: 20px;
        height: 20px;
        background-color: white;
        margin-top: -9px;
        margin-left: -10px;
        box-shadow: 0 3px 6px ${VARIABLES.COLORS.SHADOW_2};
      }
    }

    .image-control {
      &.zoom-icon {
        flex: 0 0 20px;

        &.zoom-in {
          flex: 0 0 26px;
        }
      }
    }
  }

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 1367.98px) {
  }

  @media all and (max-width: 1600.98px) {
    /* .button {
      &.close {
        flex: 0 0 140px;
      }

      &.cancel {
        flex: 0 0 140px;
      }

      &.save {
        flex: 0 0 140px;
      }
    } */
  }

  @media all and (max-width: 1440.98px) {
    /* .button {
      &.close {
        flex: 0 0 130px;
      }

      &.cancel {
        flex: 0 0 130px;
      }

      &.save {
        flex: 0 0 130px;
      }
    } */
  }

  @media all and (max-width: 1366.98px) {
    .button {
      min-width: 120px;

      /* &.close {
        flex: 0 0 120px;
      }

      &.cancel {
        flex: 0 0 120px;
      }

      &.save {
        flex: 0 0 120px;
      } */
    }
  }

  @media all and (max-width: 1280.98px) {
    /* padding: 10px;

    .button {
      &.close {
        flex: 0 0 110px;
      }

      &.cancel {
        flex: 0 0 110px;
      }

      &.save {
        flex: 0 0 110px;
      }
    } */
  }

  @media all and (max-width: 1024.98px) {
    /* padding: 8px;

    .button {
      &.close {
        flex: 0 0 100px;
      }

      &.cancel {
        flex: 0 0 100px;
      }

      &.save {
        flex: 0 0 100px;
      }
    } */
  }
`

export const ModalCloseButtonStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  top: 20px;
  right: 23px;
  position: absolute;
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0;
  transition: all ${VARIABLES.TRANSITIONS.VERY_FAST} ease-in;
  transition-delay: ${VARIABLES.TRANSITIONS.VERY_FAST};

  /* Child element styles
  ------------------------------- */

  /* States
  ------------------------------- */

  /* Modifiers
  ------------------------------- */

  /* States with modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
  }

  @media all and (max-width: 1280.98px) {
  }

  @media all and (max-width: 1024.98px) {
  }
`
